
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {ref, set} from 'firebase/database';
import {db} from '@/firebase';
import {PadoRoll} from '@/types/PadoRoll';
import PadoStatsComponent from '@/components/ParceDomine/PadoStatsComponent.vue';
import {AzrRoll} from "@/types/AzrRoll";
import AzrCharSheetComponent from "@/components/Azuria/AzrCharSheetComponent.vue";
import AzrPlayerInventoryComponent from "@/components/Azuria/AzrPlayerInventoryComponent.vue";
import {RollMixin} from '@/mixins/RollMixin';

@Component({
    components: {
        AzrPlayerInventoryComponent,
        AzrCharSheetComponent,
        PadoStatsComponent
    },
})
export default class AzrPlayerComponent extends mixins(RollMixin) {
    modalHealth = false;
    modalRi = false;
    modalHealthText = '';
    modalRiText = '';

    async roll(stat: string): Promise<void> {
        if (this.game && this.game.characters[this.$store.state.user.uid]) {
            const roll: AzrRoll = new AzrRoll(stat, this.game.characters[this.$store.state.user.uid].name);
            await roll.roll(this.game.characters[this.$store.state.user.uid], this.secret);
            await this.addRoll(roll);
            await this.addGlobalRoll(roll);
        }
    }

    async useAbility(name: string): Promise<void> {
        await (set(ref(db, `/jdrs/${this.game.id}/characters/${this.$store.state.user.uid}`), this.game.characters[this.$store.state.user.uid]));
        const abilityRoll = new PadoRoll(name, this.game.characters[this.$store.state.user.uid].name);
        abilityRoll.critic = false;
        abilityRoll.passed = true;
        abilityRoll.rolled = 0;
        abilityRoll.text = name;
        abilityRoll.setCSSClass();
        await this.addGlobalRoll(abilityRoll);
        await this.addRoll(abilityRoll);
    }
}
